import { gql, TypedDocumentNode } from "@apollo/client";

import { FlowsProject, FlowsProjectRoleBinding } from "types/generated";

export type FlowsProjectsData = {
  flowsProjects: Array<
    Pick<FlowsProject, "id" | "name"> & {
      roleBindings: Array<Pick<FlowsProjectRoleBinding, "id">>;
    }
  >;
};

export type FlowsProjectData = FlowsProjectsData["flowsProjects"][number];

export const FLOWS_PROJECTS: TypedDocumentNode<FlowsProjectsData> = gql`
  query FlowsProjects {
    flowsProjects {
      id
      name
      roleBindings {
        id
      }
    }
  }
`;
